export type ModelPlan = {
  providerId?: string;
  model: string;
  comparisonModels?: string[];
  fallbackModel?: string;
  rules?: Record<string, unknown>;
};

export function routeKey(providerId: string, model: string) {
  return providerId ? `${providerId}||${model}` : model;
}

export function parseRouteKey(value: string, defaultProviderId = "") {
  const separator = value.lastIndexOf("||");
  return separator < 0
    ? { providerId: defaultProviderId, model: value }
    : { providerId: value.slice(0, separator), model: value.slice(separator + 2) };
}

export function candidateKeys(config: ModelPlan) {
  const providerId = config.providerId || "";
  const values = (config.comparisonModels || []).map(item => {
    const parsed = parseRouteKey(item, providerId);
    return routeKey(parsed.providerId, parsed.model);
  });
  if (config.fallbackModel) values.push(routeKey(String(config.rules?.fallbackProviderId || providerId), config.fallbackModel));
  return [...new Set([config.model ? routeKey(providerId, config.model) : "", ...values].filter(Boolean))].slice(0, 12);
}

export function providerLabel(providerId: string, providers: Array<{ id: string; name: string }>) {
  return providers.find(provider => provider.id === providerId)?.name || providerId || "Custom";
}

export function routeLabel(value: string, providers: Array<{ id: string; name: string }>, defaultProviderId = "") {
  const parsed = parseRouteKey(value, defaultProviderId);
  return `${parsed.model} · ${providerLabel(parsed.providerId, providers)}`;
}
